import React from "react";
import {Row,Col} from "react-bootstrap"

const Naglowek = () => {
        return( 
                <Row className= "jumbotron naglowek">
                <Col xs={2}><img src={"/KMP_rozeta.png"} alt="Logo KMP"/></Col>
                <Col xs={10}><h1 className="well">Komenda Miejska Policji w Łodzi</h1></Col>
                </Row>
        )
}

export default Naglowek